import { render, staticRenderFns } from "./summary-graph.vue?vue&type=template&id=023b5f61&"
import script from "./summary-graph.vue?vue&type=script&lang=js&"
export * from "./summary-graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports